export default {
  login_mfa: {
    title: '@:login.title',
    message: 'ส่ง SMS พร้อมรหัสยืนยันไปยังหมายเลขโทรศัพท์ที่คุณลงทะเบียนแล้ว\nป้อนรหัสยืนยันแล้วกดปุ่มเข้าสู่ระบบ\nเวลาสิ้นสุดคือ 5 นาที',
    button_submit: '@:login.login',
    button_resend: 'ส่งรหัสยืนยันใหม่',
    alert_success: 'ส่งรหัสยืนยันใหม่แลัว',
    alert_error: 'ส่งรหัสการยืนยันใหม่ไม่สำเร็จ',
    error: '@:common.error.code_9999',
    no_phone_number_message: 'ไม่สามารถใช้การยืนยันตัวตนทาง SMS ได้ เนื่องจากหมายเลขโทรศัพท์ของผู้ใช้ไม่ได้ลงทะเบียน\n\nติดต่อผู้ดูแลระบบของบริษัทของคุณเพื่อเพิ่มหมายเลขโทรศัพท์ของคุณ',
  },
}
